var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_89578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4171 34.1025C55.6145 34.1025 55.0795 34.6561 55.0795 35.4863V53.4752C55.0795 54.3055 54.5444 54.859 53.7419 54.859H5.58677C4.78416 54.859 4.24917 54.3054 4.24917 53.4752V35.4863C4.24917 34.656 3.71406 34.1025 2.91157 34.1025C2.10908 34.1025 1.57397 34.6561 1.57397 35.4863V53.4752C1.57397 55.8277 3.31287 57.6265 5.58688 57.6265H53.7419C56.0159 57.6265 57.7548 55.8277 57.7548 53.4752V35.4863C57.7548 34.656 57.2197 34.1025 56.4171 34.1025Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0795 14.7305H4.24924C1.97523 14.7305 0.236328 16.5293 0.236328 18.8818V27.7379C0.236328 29.675 1.57393 31.3356 3.31294 31.7507L24.3139 36.5939V41.0219C24.3139 41.8522 24.849 42.4056 25.6515 42.4056H33.6773C34.4799 42.4056 35.0149 41.8521 35.0149 41.0219V36.5939L56.0158 31.7507C57.7549 31.3356 59.0925 29.675 59.0925 27.7378V18.8816C59.0925 16.5293 57.3536 14.7305 55.0795 14.7305ZM32.3397 39.6382H26.9892V34.1032H32.3397V39.6382ZM56.4171 27.7378C56.4171 28.4296 56.0158 28.9832 55.347 29.1215L35.0149 33.8263V32.7193C35.0149 31.889 34.4798 31.3356 33.6773 31.3356H25.6515C24.8489 31.3356 24.3139 31.8892 24.3139 32.7193V33.8263L3.98174 29.1216C3.31294 28.9832 2.91164 28.4297 2.91164 27.7379V18.8818C2.91164 18.0515 3.44675 17.498 4.24924 17.498H55.0795C55.8821 17.498 56.4171 18.0516 56.4171 18.8818V27.7378Z",
    fill: "#624949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3532 5.04297H22.9768C20.7028 5.04297 18.9639 6.84183 18.9639 9.19425V10.578C18.9639 11.4083 19.499 11.9617 20.3015 11.9617C21.104 11.9617 21.6391 11.4081 21.6391 10.578V9.19425C21.6391 8.36397 22.1742 7.81053 22.9767 7.81053H36.3531C37.1557 7.81053 37.6907 8.36409 37.6907 9.19425V10.578C37.6907 11.4083 38.2258 11.9617 39.0283 11.9617C39.8309 11.9617 40.3659 11.4081 40.3659 10.578V9.19425C40.3661 6.84183 38.6272 5.04297 36.3532 5.04297Z",
    fill: "#624949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_89578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.8561,
    height: 60.8856,
    fill: "white",
    transform: "translate(0.236328 0.891602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.b612ae2789c98a1b189fda4ebd5d4c9f.svg";
export { ForwardRef as ReactComponent };